import { render, staticRenderFns } from "./UserTokensList.vue?vue&type=template&id=0b2832c0&scoped=true&"
import script from "./UserTokensList.vue?vue&type=script&lang=ts&"
export * from "./UserTokensList.vue?vue&type=script&lang=ts&"
import style0 from "./UserTokensList.vue?vue&type=style&index=0&id=0b2832c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2832c0",
  null
  
)

export default component.exports